<script>
export default {
    name: 'ProgressBar',
    props: {
        gap: {
            type: Number,
            default: 1,
        },
        height: {
            type: Number,
            default: 4,
        },
        sections: {
            type: Array,
            default: () => [1, 3, 5, 1],
        },
        progress: {
            type: Array,
            default: () => [100, 20, 0, 0],
        },
        animate: {
            type: Boolean,
            default: true,
        },
        progressColor: {
            type: String,
            default: 'bg-primary',
        },
    },
    computed: {
        sectionsLength() {
            return this.sections.reduce((a, b) => a + b, 0)
        },
    },
    watch: {
        progress: {
            immediate: true,
            deep: true,
            handler(progress) {
                const index = progress.findIndex(
                    (state, index) => state > 0 && progress[index + 1] === 0
                )
                if (index > -1) this.setProgressWidth(progress[index])
            },
        },
    },
    methods: {
        setProgressWidth(width) {
            this.$nextTick(() => {
                this.$refs.progressWrapper?.style?.setProperty(
                    '--progress-bar-animation-width',
                    `${width}%`
                )
            })
        },
    },
}
</script>

<template lang="pug">
.progress-wrapper(:style="{margin: `0 -${gap}px`}" ref="progressWrapper")
    .progress.bg-e8(
        v-for="(section, index) in sections"
        :key="`progressBarSection-${index}-${_uid}`"
        :style="{width: `calc(${(100/sectionsLength)*section}% - ${gap*2}px)`, height: `${height}px`, margin: `0 ${gap}px`}")
        .progress-bar(
            role="progressbar"
            :class="[progressColor, {'in-progress': progress[index] > 0 && progress[index + 1] === 0 && animate}]"
            :style="{width: `${progress[index]}%`}"
            :aria-valuenow="progress[index]"
            aria-valuemin="0"
            aria-valuemax="100")
</template>
